import React from "react";
import { useTranslation } from "react-i18next";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import Search from "components/search/Search";

interface IReportsSearchBarProps {
  historyKey: string;
  onSearch: (value: string) => void;
}

export default function ReportsSearchBar(props: IReportsSearchBarProps) {
  const { historyKey, onSearch } = props;
  const { t } = useTranslation();

  return (
    <div className="reports-list-search">
      <Search
        className="reports-list-search__input"
        historyKey={historyKey}
        searchCallback={onSearch}
        placeholder={t("Search reports by name or description...")}
        showDropdown={false}
        debounceTime={0}
        icon={faMagnifyingGlass}
      />
    </div>
  );
}
